const state = {
  canDownloadLoading: false
}

const getters = {
  canDownloadLoading: state => state.canDownloadLoading
}

const mutations = {
  setCanDownloadLoading (state, value) {
    state.canDownloadLoading = value
  }
}

const actions = {
  setCanDownloadLoading ({ commit }, value) {
    commit('setCanDownloadLoading', value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/files/download/download.js